import { motifsList } from 'helper/helper';
import UseContext from 'hooks/useContext';
import { useEffect, useState } from 'react';

const MOTIF_MODAL_BY_ID = {
  ctu: 'cM_temporaire',
  remplacement: 'cM_remplacement',
  attente_recrutement: 'cM_attRecrutement',
  accroissement: 'cM_accroissement',
  saisonnier: 'cM_saisonnier',
};

const ReasonAppeal = () => {
  const { dataCreateMission, setModalShow, setModalType } = UseContext();
  const motifs = motifsList();

  const [selectedId, setSelectedId] = useState(null);

  const openCreateMissionMotifModal = (idReason) => {
    const modalType = MOTIF_MODAL_BY_ID[idReason];
    if (!modalType) return;
    setSelectedId(idReason);
    setModalType(modalType);
    setModalShow(true);
  };

  useEffect(() => {
    const type = dataCreateMission?.motif?.type;
    if (type) {
      const found = motifs.find((m) => m.type === type);
      if (found) {
        setSelectedId(found.id);
      }
    }
  }, [dataCreateMission?.motif?.type]);

  return (
    <div className="flex flex-col gap-4">
      <div className="text-xl">Motifs de recours</div>
      <div className="flex flex-col gap-2">
        {motifs.map((m) => {
          const isSelected = selectedId === m.id;
          return (
            <div
              key={m.id}
              className={`w-full border p-6 cursor-pointer ${
                isSelected
                  ? 'bg-yellow-50 border-yellow-500'
                  : 'bg-grey-50 border-grey-500'
              }`}
              onClick={() => openCreateMissionMotifModal(m.id)}
            >
              {m.label}
            </div>
          );
        })}
      </div>
    </div>
  );
};

const slideOverAddMissionMotif = () => {
  return (
    <div className="flex flex-col gap-8">
      <ReasonAppeal />
    </div>
  );
};

export default slideOverAddMissionMotif;
